import { createUseStyles } from 'react-jss';
import { ITheme } from '../../components/theme';


type RuleNames =
  | 'mainBlock'
  | 'title'
  | 'qual'
  | 'paragraph'
  | 'contentBlock';

const PREFIX = 'OpportunityDetails';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      mainBlock: {
        display: 'flex',
        justifyContent: 'center',
        margin: '0px auto',
        width: '1160px',
        padding: '32px 0 84px',
        flexDirection: 'column',
        alignItems: 'flex-start',

        '& .MuiTypography-root': {
          fontFamily: theme.sfPro,
        },
        '& .MuiTableCell-root': {
          fontFamily: theme.sfPro,
        },
        '& .MuiPaper-root': {
          fontFamily: theme.sfPro,
        },
      },
      contentBlock: {
        padding: 0,
        display: 'flex',
        justifyContent: 'center',
        gap: 40,
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
      title: {
        fontFamily: theme.caslonDoric,
        fontSize: 20,
        margin: '0 0 8px',
      },
      qual: {
        display: 'flex',
        alignItems: 'center',
        fontSize: 14,
        lineHeight: '143%',
        margin: '8px 0 0',
        '& img': {
          marginRight: 8,
        },
      },
      paragraph: {
        color: 'rgba(0, 0, 0, 0.5)',
        fontSize: 14,
        margin: 0,
      },
      '@media (max-width: 1530px)': {
        mainBlock: {
          margin: '0px 9.7%',
        },
      },
    }
  ),
  { name: PREFIX },
);
